const defaultApiRoute = "https://api.moncasan.com/api";

export default {
    defaultApiRoute: defaultApiRoute,
};
